import { getShippingCountries } from '@/apis/main';
import { useQuery } from '@tanstack/react-query';
import useApi from './useApi';

export const useShippingCountries = () => {
  const { fetchApi } = useApi();
  const { data } = useQuery({
    queryFn: () => fetchApi((accessToken) => getShippingCountries(accessToken)),
    queryKey: ['shipping-countries'],
    staleTime: 1000 * 60 * 60
  });

  return { countries: data?.countries ?? [] };
};
